(function (Drupal) {
    Drupal.behaviors.slickInit = {
        attach: function (context, settings) {
            const awardCards = context.querySelectorAll('.award-items-wrapper');

            awardCards.forEach(function (awardCard) {
                if (!awardCard.classList.contains('slick-initialized')) {
                    jQuery(awardCard).slick({
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        speed: 700,
                        cssEase: 'ease-in-out',
                        prevArrow: '<button type="button" aria-label="Previous slide" class="slick-prev slick-arrow"><svg width="448" height="386" viewBox="0 0 448 386" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M438.6 215.6C451.1 203.1 451.1 182.8 438.6 170.3L278.6 10.2998C266.1 -2.2002 245.8 -2.2002 233.3 10.2998C220.8 22.7998 220.8 43.0998 233.3 55.5998L338.8 161H32C14.3 161 0 175.3 0 193C0 210.7 14.3 225 32 225H338.7L233.4 330.4C220.9 342.9 220.9 363.2 233.4 375.7C245.9 388.2 266.2 388.2 278.7 375.7L438.7 215.7L438.6 215.6Z" fill="#ffffff"/></svg></button>',
                        nextArrow: '<button type="button" aria-label="Next slide" class="slick-next slick-arrow"><svg width="448" height="386" viewBox="0 0 448 386" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M438.6 215.6C451.1 203.1 451.1 182.8 438.6 170.3L278.6 10.2998C266.1 -2.2002 245.8 -2.2002 233.3 10.2998C220.8 22.7998 220.8 43.0998 233.3 55.5998L338.8 161H32C14.3 161 0 175.3 0 193C0 210.7 14.3 225 32 225H338.7L233.4 330.4C220.9 342.9 220.9 363.2 233.4 375.7C245.9 388.2 266.2 388.2 278.7 375.7L438.7 215.7L438.6 215.6Z" fill="#ffffff"/></svg></button>',
                        responsive: [
                            {
                                breakpoint: 1440,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                }
            });                    
        }
    };
})(Drupal);
